import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { forgotPasswordAction } from "../redux/action/auth";
import { notifyError } from "../helpers/helper";

function ForgotPassword() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.account);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return notifyError("Please enter your email address");
    dispatch(
      forgotPasswordAction(email, () => {
        setSent(true);
      })
    );
  };

  return (
    <div className="auth-page">
      <div className="auth-from">
        <div className="container">
          <div className="flex justify-center">
            <img src="/images/wasteknot_logo.png" alt="logo" className="logo" />
          </div>

          <h4 className="cercle-purple-text text-center">Forgot Password</h4>

          {sent ? (
            <>
              <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
                <i className="material-symbols-outlined">mark_email_read</i>
                <p className="ml-1">
                  If an account exists for <b>{email}</b>, we've sent a password
                  reset link to it. The link expires in 15 minutes. Please check
                  your inbox and spam folder.
                </p>
              </div>
              <div className="mt-1 text-center">
                <Link to="/" className="primary semi-bold">
                  Back to Sign In
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="grey-text text-center">
                Enter the email associated with your account and we'll send you a
                link to reset your password.
              </p>

              <form className="mt-1" onSubmit={handleSubmit}>
                <div className="input-field-style">
                  <span className="material-symbols-outlined primary">
                    person
                  </span>
                  <input
                    className="browser-default"
                    placeholder="Enter your email ID"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="submit-btn mv-2 column flex align-center">
                  <button
                    className="btn full-width mb-1 mt-1"
                    type="submit"
                    disabled={!email || loading}
                  >
                    {loading ? (
                      <ClipLoader color="#fff" size={20} />
                    ) : (
                      "Send Reset Link"
                    )}
                  </button>
                </div>
              </form>

              <div className="mt-1 text-center">
                <Link to="/" className="primary semi-bold">
                  Back to Sign In
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
